module.exports = __webpack_public_path__ + "img/11.3c1a49a3.png";